import React, { useState, useEffect, Fragment } from 'react';
import Gallery from 'react-photo-gallery';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Row,
  CardImg,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import {
  gAPI_Call_Flows,
  gAPI_QuestionSets,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
let arr = [];
export default function ConfigurationBehavior({
  integration,
  integrationProperties,
  allProperties,
  locale,
  saveIntegration,
}) {
  const [callFlow, setCallFLowList] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [configurationSettings, setConfigurationSettings] = useState(
    integration?.phoneSuiteIntegration?.configurationSettings || {
      welcomeMessage: '',
      waitingSeconds: 0,
      internalWelcomeMessage: '',
      gptInstructions: '',
      openAIModal: 'GPT-3.5Turbo',
      activeCallFlowlst: [],
      isGenAI: false,
      isDynamicConversationFlow: false,
      assistantId: '',
      humanAssistant: false,
      e64Format: '',
      speechToText: '',
      replaces: '',
      keywords: '',
    }
  );
  const [assistantList, setAssistantList] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );

  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);
  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Call_Flows}`,
    }).then((res) => {
      setCallFLowList(res.data);
    });
  }, [integrationProperties, allProperties]);

  const selectedImage = (image) => {
    setConfigurationSettings({
      ...configurationSettings,
      serviceProviderLogo: image.src,
    });
  };

  const handleChangeAssistantId = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      assistantId: e.target.value,
    });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  useEffect(() => {
    if (selectedProperty) {
      loadResponse();
    }
  }, [selectedProperty]);

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleCheckChange = (e) => {
    // if (e.target.checked) {
    //   arr[e.target.id] = e.target.value;
    // }
    // if (!e.target.checked) {
    //   arr[e.target.id] = undefined;
    // }
    // const filterList = arr.filter(elem => elem !== undefined || null);
    // setList(filterList);

    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    const propertyArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    setList(propertyArr);
  };

  const handleSave = () => {
    saveIntegration({ configurationSettings: configurationSettings });
    arr = [];
    setList([]);
  };

  const handleConfigurationChange = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeWelcomeMessage = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      welcomeMessage: e.target.value,
    });
  };

  const handleWaitingSeconds = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      waitingSeconds: e.target.value,
    });
  };
  const handleChangeInternalWelcomeMessage = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      internalWelcomeMessage: e.target.value,
    });
  };

  const handleChangeGenerativeInstructions = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      gptInstructions: e.target.value,
    });
  };

  const handleOpenAiModal = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      openAIModal: e.target.value,
    });
  };

  const handleActivateAiFlows = (val) => {
    let callFlow = configurationSettings.activeCallFlows;
    if (callFlow.filter((f) => f === val).length > 0) {
      callFlow = callFlow.filter((f) => f !== val);
    } else {
      callFlow.push(val);
    }
    setConfigurationSettings({
      ...configurationSettings,
      activeCallFlows: callFlow,
    });
  };

  const handleCheckedGenerativeGTP3 = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      isGenAI: e,
      isDynamicConversationFlow: false,
    });
  };

  const handleHumanAsistant = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      humanAssistant: e,
    });
  };

  const handleES6Format = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      e64Format: e.target.value,
    });
  };

  const handleCheckedOpenAIEnabled = (e) => {
    setConfigurationSettings({
      ...configurationSettings,
      isDynamicConversationFlow: e,
      isGenAI: false,
    });
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Configure AI Voice Assistant Behaviour
            {/* <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            /> */}
          </h6>
        </div>

        <Separator className="mb-3"></Separator>

        <div className="text-left">
          <div className="mb-3">
            <h5>Welcome message</h5>
            <p className="my-2">
              Hint: Try adding three dots “ … ” to create a longer pause. The
              filler words “um” and “uh” are also supported. Shorter sentences
              might improve pronunciation.
            </p>
            <Label>
              <b>External Call</b>
            </Label>
            <Input
              className="form-control"
              name="name"
              type="textarea"
              defaultValue={configurationSettings.welcomeMessage}
              placeholder="Welcome, how can I help you today?"
              onChange={handleChangeWelcomeMessage}
            />
            <Label className="mt-2">
              <b>Waiting Time (In Seconds)</b>
            </Label>
            <Input
              className="form-control"
              name="waitingSeconds"
              type="number"
              defaultValue={configurationSettings.waitingSeconds}
              onChange={handleWaitingSeconds}
            />
            <Label className="mt-2">
              <b>Internal Call</b>
            </Label>
            <Input
              className="form-control"
              name="name"
              type="textarea"
              defaultValue={configurationSettings.internalWelcomeMessage}
              placeholder="Welcome, how can I help you today?"
              onChange={handleChangeInternalWelcomeMessage}
            />
          </div>

          <Separator className="my-2"></Separator>
          <div className="ml-2">
            <h5 style={{ marginTop: '0.15rem' }}>Choose your NLP </h5>
            <div className="d-flex ml-2 mb-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>Gen AI</h7>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={configurationSettings.isGenAI}
                name="isGenAI"
                onChange={(e) => handleCheckedGenerativeGTP3(e)}
              />
            </div>
            <p className="ml-2">
              Gen AI excels at answering questions by using your Knowledge Hub
              to provide accurate and relevant information.
            </p>
            <div className="d-flex ml-2 mb-2 mt-2">
              <h7 style={{ marginTop: '0.15rem', marginBottom: '4px' }}>
                Dynamic Conversation Flow
              </h7>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={configurationSettings.isDynamicConversationFlow}
                name="isDynamicConversationFlow"
                onChange={(e) => handleCheckedOpenAIEnabled(e)}
              />
            </div>
            <p className="ml-2 mb-2">
              Conversation flows are useful to provide more detailed,
              step-by-step instructions to guide a customer through a process or
              task until completion.
            </p>
          </div>
          {assistantList &&
            assistantList !== null &&
            configurationSettings.isDynamicConversationFlow === true && (
              <Fragment>
                <Separator className="my-2"></Separator>
                <div className="mb-1 ml-2 ">
                  {assistantList.length > 0 ? (
                    <Input
                      className="border p-2 mb-3"
                      type="select"
                      name="assistantId"
                      placeholder="Dynamic Conversation Flow"
                      value={configurationSettings.assistantId}
                      onChange={handleChangeAssistantId}
                    >
                      <option value="">
                        Select a Dynamic Conversation Flow
                      </option>
                      {assistantList.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {`${assist.name} (${assist.id})`}
                        </option>
                      ))}
                    </Input>
                  ) : (
                    <Input
                      className="border p-2 mb-3"
                      type="text"
                      name="assistantId"
                      onChange={handleChangeAssistantId}
                      placeholder="Dynamic Conversation Flow"
                      defaultValue={configurationSettings.assistantId}
                    />
                  )}
                </div>
              </Fragment>
            )}
          {assistantList &&
            assistantList !== null &&
            configurationSettings.isGenAI === true && (
              <Fragment>
                <div className="mb-3">
                  <h5>Generative AI (GPT) instructions for Q&A</h5>
                  <p className="my-2">
                    Hint: Add a line that’s appended to every customer query
                    before sending it to the GPT models. This provides guidance
                    to the model.
                  </p>
                  <Input
                    className="form-control"
                    name="name"
                    type="textarea"
                    placeholder="You are a phone assistant working for the Paradise Resort. Be truthful and precise."
                    defaultValue={configurationSettings.gptInstructions}
                    onChange={handleChangeGenerativeInstructions}
                  />
                </div>
                <div className="mb-3">
                  <h6>Select OpenAI model</h6>
                  <p className="my-2">
                    Hint: Add a line that’s appended to every customer query
                    before sending it to the GPT models. This provides guidance
                    to the model.
                  </p>
                  <Input
                    className="form-control"
                    type="select"
                    placeholder="You are a phone assistant working for the Paradise Resort. Be truthful and precise."
                    defaultValue={configurationSettings.openAIModal}
                    onChange={handleOpenAiModal}
                  >
                    <option value={'GPT-3.5Turbo'}>
                      GPT-3.5 Turbo (Fast and affordable)
                    </option>
                    <option value="GPT-4">
                      GPT-4 (Fastest and most capable, but expensive)
                    </option>
                    <option value="gpt-4o-mini">
                      GPT-4o-mini ( Affordable and intelligent small model for
                      fast, lightweight tasks)
                    </option>
                  </Input>
                </div>
              </Fragment>
            )}
          <Separator className="my-2"></Separator>
          <div className="ml-2 mb-3">
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                Human assistance needed or requested
              </h7>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={configurationSettings?.humanAssistant}
                name="humanAssistant"
                onChange={(e) => handleHumanAsistant(e)}
              />
            </div>
            {configurationSettings.humanAssistant === true && (
              <div className="mb-3">
                <p className="my-2">
                  Add a number in ES6 Format, which will be used to transfer the
                  AI call to in case of customer request of determined by the AI
                  voice
                </p>
                <Input
                  className="form-control"
                  name="e64Format"
                  type="text"
                  placeholder=""
                  defaultValue={configurationSettings.e64Format}
                  onChange={(e) => handleES6Format(e)}
                />
              </div>
            )}
          </div>
          <Separator className="my-2"></Separator>
          <div className="mb-3">
            <h5>Custom Vocabulary to improve speech recognition</h5>
            <p className="my-2">
              Find and Replace searches for terms or phrases in speech and
              replaces them.
            </p>
            <p className="my-2">
              Use Keywords to boost or suppress terminology specific to your
              business.
            </p>
          </div>
          <div className="ml-2 mb-3">
            <h6>Speech to Text Language</h6>
            <Input
              className="form-control"
              type="select"
              defaultValue={configurationSettings?.speechToText}
              name="speechToText"
              onChange={handleConfigurationChange}
            >
              <option value={''}>Please Select</option>
              <option value={'en'}>en</option>
              <option value={'en-US'}>en-US</option>
              <option value={'en-NZ'}>en-NZ</option>
              <option value={'en-IN'}>en-IN</option>
              <option value={'en-AU'}>en-AU</option>
            </Input>
          </div>
          <div className="ml-2 mb-3">
            <h6>Find and Replace</h6>
            <Input
              className="form-control"
              type="textarea"
              placeholder="monika:Monica&hailee:hailey"
              defaultValue={configurationSettings?.replaces}
              name="replaces"
              onChange={handleConfigurationChange}
            ></Input>
          </div>
          <div className="ml-2 mb-3">
            <h6>Keywords</h6>
            <Input
              className="form-control"
              type="textarea"
              placeholder="snuffleupagus:5&Rotorua:3"
              defaultValue={configurationSettings?.keywords}
              name="keywords"
              onChange={handleConfigurationChange}
            ></Input>
          </div>
          {/* <Separator className="my-2"></Separator> */}
          <div className="mb-2" style={{ display: 'none' }}>
            <h5>Activate AI Call Flows</h5>
            <p className="my-2">
              Choose from a library of pre-build voice AI call flows. Each call
              flow might need its own settings based on the functionality.
            </p>

            {callFlow !== undefined &&
              callFlow.length > 0 &&
              callFlow.map((m) => (
                <CustomInput
                  key="welcomeMessageFirst"
                  type="checkbox"
                  checked={
                    configurationSettings.activeCallFlows.filter(
                      (f) => f === m.code
                    ).length > 0
                      ? true
                      : false
                  }
                  onChange={(e) => handleActivateAiFlows(m.code)}
                >
                  <span>{m.name}</span>
                </CustomInput>
              ))}
          </div>
        </div>
        <div className="text-center">
          <div
            className="mb-2 text-center"
            style={{ marginTop: '20px' }}
          >
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="secondary"
              className='ml-2'
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </div>
        </div>
        {ImageGalleryButton()}
      </CardBody>
    );
  };

  return <Card className="mb-4"> {Edit()}</Card>;
}
